export const HOMES = {
    homes: "homes",
}

export const PRODUCTOS = {
    productos: "nuestros-productos"
}

export const NOSOTROS = {
    nosotros: "nosotros"
}

export const FAQ = {
    faq: "preguntas-frecuentes"
}

export const WHATS = {
    whats: "whats-apps"
}

export const HEADER = {
    header: "headers"
}

export const FOOTER = {
    footer: "footers"
}

export const CHAT = {
    chat: "chatbot"
}

export const PROMOCIONES = {
    promociones: "promociones"
}